import { TOKEN_ID_REGEX } from "@/constants";
import { type Message } from "@/features/chat/types/sdk";

/**
 * Extract the base message ID from a message, removing any token-based suffix.
 * Backend sends messages with IDs like: "msg-123-token-0", "msg-123-token-1", etc.
 * This function returns "msg-123" to deduplicate streaming tokens.
 *
 * @param message - The message to extract the base ID from
 * @returns The base message ID without token suffix, or the original ID if no suffix found, or undefined if no ID
 */
export function getBaseMessageId(message: Message): string | undefined {
  if (!message.id) return undefined;
  const match = TOKEN_ID_REGEX.exec(message.id);
  return match ? match[1] : message.id;
}
